import { CryptoError } from "./errors.js";
const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
export function base32Encode(bytes) {
    let bits = 0;
    let value = 0;
    let out = "";
    for (let i = 0; i < bytes.length; i += 1) {
        const byte = bytes[i];
        if (byte === undefined) {
            throw new CryptoError("invalid-input", "Unreachable byte index.");
        }
        value = (value << 8) | byte;
        bits += 8;
        while (bits >= 5) {
            bits -= 5;
            const idx = (value >>> bits) & 31;
            const ch = ALPHABET[idx];
            if (ch === undefined) {
                throw new CryptoError("invalid-input", "Base32 index out of range.");
            }
            out += ch;
        }
    }
    if (bits > 0) {
        const idx = (value << (5 - bits)) & 31;
        const ch = ALPHABET[idx];
        if (ch === undefined) {
            throw new CryptoError("invalid-input", "Base32 index out of range.");
        }
        out += ch;
    }
    return out;
}
export function base32Decode(input) {
    const clean = input.trim().replace(/=+$/, "").replace(/[\s-]/g, "").toUpperCase();
    if (clean.length === 0) {
        throw new CryptoError("invalid-input", "Empty base32 input.");
    }
    let bits = 0;
    let value = 0;
    const out = [];
    for (const ch of clean) {
        const idx = ALPHABET.indexOf(ch);
        if (idx < 0) {
            throw new CryptoError("invalid-input", "Invalid base32 character.");
        }
        value = (value << 5) | idx;
        bits += 5;
        if (bits >= 8) {
            bits -= 8;
            out.push((value >>> bits) & 0xff);
        }
    }
    return new Uint8Array(out);
}
//# sourceMappingURL=base32.js.map